module.exports = __webpack_public_path__ + "img/15.e5493c2b.png";